import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import SmartLinkListIcon from '@atlaskit/icon/core/smart-link-list';
import { IconTile } from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlaskit/primitives/compiled';

import { usePageSpaceKey } from '@confluence/page-context';

import { buildCreationLink } from '../CreateContentRouteComponent/createContentRouteUtils.ts';

import { ContentTreeOnboardingItem, SOURCE_NAME } from './ContentTreeOnboardingItem.tsx';

export const CreateDatabaseOnboardingItem = () => {
	const [spaceKey] = usePageSpaceKey();

	const createDatabaseLink = buildCreationLink({
		contentType: 'database',
		source: SOURCE_NAME,
		spaceKey,
	});

	return (
		<ContentTreeOnboardingItem
			href={createDatabaseLink}
			iconGlyph={
				<IconTile
					icon={() => <SmartLinkListIcon label="" color={token('color.text.inverse')} />}
					appearance="purpleBold"
					label=""
					size="24"
				/>
			}
			contentType="database"
		>
			<Text maxLines={1} color="color.text.subtle">
				<FormattedMessage {...i18n.addYourFirstDatabase} />
			</Text>
		</ContentTreeOnboardingItem>
	);
};

const i18n = defineMessages({
	addYourFirstDatabase: {
		id: 'create-blank-fabric-page.content-tree-onboarding.new-database',
		defaultMessage: 'Add your first database',
		description: 'Text shown in empty content tree which prompts user to create a new database.',
	},
});
